import { useCallback, useState } from 'react'

type TxData = { finished: boolean; txHash?: string; amount: string }

export function useTxSuccessState() {
  const [txData, setTxData] = useState<TxData>({ finished: false, amount: '' })

  const resetTxState = useCallback(() => {
    setTxData({ finished: false, txHash: undefined, amount: '' })
  }, [])

  const setTransactionFinished = useCallback(({ txHash, amount }: { txHash: string | undefined; amount: string }) => {
    setTxData({ finished: true, txHash, amount })
  }, [])

  return { txData, resetTxState, setTransactionFinished }
}
